var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redeem-location-main-page"},[_c('redeem-location-header'),_c('main',[(_vm.redeemLocation)?_c('location-redeem',{attrs:{"redeemLocation":_vm.redeemLocation}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }